import formbricks from "@formbricks/js";

// I don't think we need to put those in env variables since it's a specific self hosted integration anyway...
const WORKSPACE_ID = "cmo8sd67e0005vv0158lq6hla";
const APP_URL = "https://formbricks.thetreep.com";
const FEEDBACK_ACTION = "tsam_clicked_feedback_form";

const COOKIE_CONSENT_KEY = "cookie-accepted";

export function hasFeedbackConsent(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(COOKIE_CONSENT_KEY) === "true";
}

let setupPromise: Promise<boolean> | null = null;

export function initFormbricks(): Promise<boolean> {
  if (setupPromise) return setupPromise;
  if (typeof window === "undefined") return Promise.resolve(false);
  if (!hasFeedbackConsent()) return Promise.resolve(false);

  const promise = (async () => {
    await formbricks
      .setup({ workspaceId: WORKSPACE_ID, appUrl: APP_URL })
      .catch(() => {});

    if (window.formbricks) return true;

    console.error("[formbricks] setup failed");
    setupPromise = null;
    return false;
  })();

  setupPromise = promise;
  return promise;
}

export async function trackFeedback(context: {
  env: string;
  caisse: string;
  agence: string;
}): Promise<void> {
  const ready = await initFormbricks();
  if (!ready) return;
  try {
    await formbricks.track(FEEDBACK_ACTION, { hiddenFields: context });
  } catch (err) {
    console.error("formbricks: track feedback failed", err);
  }
}
